import { isEmpty } from "lodash";
import { useContext, useEffect, useState } from "react";

import PaginationList from "../../../../utils/PaginationList/PaginationList";
import PreviewParamsOperator from "../PreviewParamsOperator/PreviewParamsOperator";
import { serviceAdminContext } from "../../../../context/Admin/ServiceAdminContext/ServiceAdminContext";
import { serviceParameters } from "../../../../utils";

const ParamsOperator = ({ step, setStep }) => {
  const { params, handleDeleteParamValue, handleEditParamOrder } =
    useContext(serviceAdminContext);

  const renderParam = (_val) => {
    let render = null;

    switch (_val?.type) {
      case "radiobutton":
        render = <RadiobuttonType data={_val} />;
        break;
      case "text":
        render = <TextType data={_val} />;
        break;
      case "multiplechoice":
        render = <MultiplechoiceType data={_val} />;
        break;
      case "datetime":
        render = <DateTimeType data={_val} />;
        break;
      case "date":
        render = <DateType data={_val} />;
        break;
      case "time":
        render = <TimeType data={_val} />;
        break;
      case "number":
        render = <NumberType data={_val} />;
        break;
      case "switch":
        render = <SwitchType data={_val} />;
        break;
      case "image":
        render = <ImageType data={_val} />;
        break;
      case "item":
        render = <ItemParam data={_val} parentStep={step} />;
        break;

      default:
        render = null;
        break;
    }

    return <div>{render}</div>;
  };

  const paramsLength = params.length;
  const items = params?.sort((a, b) => a?.order - b?.order);
  const item = items[step];
  if (paramsLength <= 0) return null;

  return (
    <div className="row justify-content-between">
      <div className="col-12 col-md-6">
        <div className="card-header text-center mb-2">عملیات</div>
        <section>
          <div
            key={item?.parameter}
            className="border border-secondary card card-body"
          >
            <div>{renderParam(item)}</div>
            <div className="d-flex justify-content-between align-items-center my-3">
              <div>
                <button
                  className="btn btn-outline-info"
                  type="button"
                  onClick={() => handleEditParamOrder(step, undefined, false)}
                  disabled={step <= 0}
                >
                  انتقال به مرحله قبل
                </button>
              </div>
              <div>
                <button
                  className="btn btn-outline-danger"
                  type="button"
                  onClick={() => {
                    handleDeleteParamValue(item);
                    if (step >= paramsLength - 1) setStep(step - 1);
                  }}
                >
                  حذف این مرحله
                </button>
              </div>
              <div>
                <button
                  className="btn btn-outline-info"
                  type="button"
                  onClick={() => handleEditParamOrder(step + 1, undefined, true)}
                  disabled={step >= paramsLength - 1}
                >
                  انتقال به مرحله بعد
                </button>
              </div>
            </div>
          </div>
          <PaginationList
            initialPage={step}
            setPageNumber={(page) => setStep(page - 1)}
            pageCount={paramsLength}
          />
        </section>
      </div>
      <div className="col-12 col-md-6">
        <div className="card-header text-center mb-2">پیش نمایش</div>
        <PreviewParamsOperator data={item} />
      </div>
    </div>
  );
};

export default ParamsOperator;

const NumberType = ({ data, unique_id }) => {
  const { handleEditParamValue } = useContext(serviceAdminContext);

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6">
            <label htmlFor="numName">عنوان پارامتر</label>
            <input
              type="text"
              value={data?.name}
              id="numName"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(data, "name", e.target.value, unique_id)
              }
            />
          </div>
          <div className="col-12 col-md-6">
            <label htmlFor="numParameter">نام پارامتر</label>
            <input
              type="text"
              value={data?.parameter}
              id="numParameter"
              disabled
              readOnly
              className="form-control bg-light disabled"
            />
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <label htmlFor="numMin">حداقل</label>
            <input
              type="number"
              value={data?.min}
              id="numMin"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "min",
                  Number(e.target.value),
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <label htmlFor="numMax">حداکثر</label>
            <input
              type="number"
              value={data?.max}
              id="numMax"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "max",
                  Number(e.target.value),
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <label htmlFor="numDefault">مقدار پیشفرض</label>
            <input
              type="number"
              value={data?.default}
              id="numDefault"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "default",
                  Number(e.target.value),
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6 col-lg-3">
            <label htmlFor="numDescription">عنوان</label>
            <input
              type="text"
              value={data?.description}
              id="numDescription"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "description",
                  e.target.value,
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6 col-lg-9">
            <label htmlFor="numDescriptionExtra">توضیحات اضافه</label>
            <input
              type="text"
              value={data?.description_extra}
              id="numDescriptionExtra"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "description_extra",
                  e.target.value,
                  unique_id
                )
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

const SwitchType = ({ data, unique_id }) => {
  const { handleEditParamValue } = useContext(serviceAdminContext);

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6">
            <label htmlFor="swName">عنوان پارامتر</label>
            <input
              type="text"
              value={data?.name}
              id="swName"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(data, "name", e.target.value, unique_id)
              }
            />
          </div>
          <div className="col-12 col-md-6">
            <label htmlFor="swParameter">نام پارامتر</label>
            <input
              type="text"
              value={data?.parameter}
              id="swParameter"
              disabled
              readOnly
              className="form-control bg-light disabled"
            />
          </div>
          <div className="col-12 col-md-6 col-lg-3">
            <label htmlFor="swDescription">عنوان</label>
            <input
              type="text"
              value={data?.description}
              id="swDescription"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "description",
                  e.target.value,
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6 col-lg-9">
            <label htmlFor="swDescriptionExtra">توضیحات اضافه</label>
            <input
              type="text"
              value={data?.description_extra}
              id="swDescriptionExtra"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "description_extra",
                  e.target.value,
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6">
            <div className="custom-control custom-switch mb-2">
              <input
                type="checkbox"
                className="custom-control-input"
                id="swDefault"
                checked={data?.default}
                onChange={(e) =>
                  handleEditParamValue(
                    data,
                    "default",
                    e.target.checked,
                    unique_id
                  )
                }
              />
              <label className="custom-control-label" htmlFor="swDefault">
                مقدار پیشفرض
              </label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const DateTimeType = ({ data, unique_id }) => {
  const { handleEditParamValue } = useContext(serviceAdminContext);

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6">
            <label htmlFor="dtName">عنوان پارامتر</label>
            <input
              type="text"
              value={data?.name}
              id="dtName"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(data, "name", e.target.value, unique_id)
              }
            />
          </div>
          <div className="col-12 col-md-6">
            <label htmlFor="dtParameter">نام پارامتر</label>
            <input
              type="text"
              value={data?.parameter}
              id="dtParameter"
              disabled
              readOnly
              className="form-control bg-light disabled"
            />
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <label htmlFor="dtStart_hour">ساعت شروع</label>
            <input
              type="number"
              value={data?.start_hour}
              id="dtStart_hour"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "start_hour",
                  Number(e.target.value),
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <label htmlFor="dtEnd_hour">حداکثر</label>
            <input
              type="number"
              value={data?.end_hour}
              id="dtEnd_hour"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "end_hour",
                  Number(e.target.value),
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <label htmlFor="dtInterval">بازه زمانی</label>
            <input
              type="number"
              value={data?.interval}
              id="dtInterval"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "interval",
                  Number(e.target.value),
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6">
            <label htmlFor="dtWait_time">تاخیر نسبت به زمان ثبت سفارش</label>
            <input
              type="number"
              value={data?.wait_time}
              id="dtWait_time"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "wait_time",
                  Number(e.target.value),
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6">
            <label htmlFor="dtWait_type">نوع تاخیر</label>
            <select
              value={data?.wait_type}
              id="dtWait_type"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "wait_type",
                  Number(e.target.value),
                  unique_id
                )
              }
            >
              <option value="0" selected={0 === data?.wait_type}>
                دقیقه
              </option>
              <option value="1" selected={1 === data?.wait_type}>
                ساعت
              </option>
              <option value="2" selected={2 === data?.wait_type}>
                روز
              </option>
            </select>
          </div>
          <div className="col-12 col-md-6 col-lg-3">
            <label htmlFor="dtDescription">عنوان</label>
            <input
              type="text"
              value={data?.description}
              id="dtDescription"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "description",
                  e.target.value,
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6 col-lg-9">
            <label htmlFor="dtDescriptionExtra">توضیحات اضافه</label>
            <input
              type="text"
              value={data?.description_extra}
              id="dtDescriptionExtra"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "description_extra",
                  e.target.value,
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12">
            <label htmlFor="dtAlert">هشدار</label>
            <input
              type="text"
              value={data?.alert}
              id="dtAlert"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(data, "alert", e.target.value, unique_id)
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

const TextType = ({ data, unique_id }) => {
  const { handleEditParamValue } = useContext(serviceAdminContext);

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6">
            <label htmlFor="txtName">عنوان پارامتر</label>
            <input
              type="text"
              value={data?.name}
              id="txtName"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(data, "name", e.target.value, unique_id)
              }
            />
          </div>
          <div className="col-12 col-md-6">
            <label htmlFor="txtParameter">نام پارامتر</label>
            <input
              type="text"
              value={data?.parameter}
              id="txtParameter"
              disabled
              readOnly
              className="form-control bg-light disabled"
            />
          </div>
          <div className="col-12 col-md-6 col-lg-3">
            <label htmlFor="txtDescription">عنوان</label>
            <input
              type="text"
              value={data?.description}
              id="txtDescription"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "description",
                  e.target.value,
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6 col-lg-9">
            <label htmlFor="txtDescriptionExtra">توضیحات اضافه</label>
            <input
              type="text"
              value={data?.description_extra}
              id="txtDescriptionExtra"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "description_extra",
                  e.target.value,
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12">
            <label htmlFor="txtAlert">هشدار</label>
            <input
              type="text"
              value={data?.alert}
              id="txtAlert"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(data, "alert", e.target.value, unique_id)
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

const MultiplechoiceType = ({ data, unique_id }) => {
  const { handleEditParamValue } = useContext(serviceAdminContext);

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6">
            <label htmlFor="mcName">عنوان پارامتر</label>
            <input
              type="text"
              value={data?.name}
              id="mcName"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(data, "name", e.target.value, unique_id)
              }
            />
          </div>
          <div className="col-12 col-md-6">
            <label htmlFor="mcParameter">نام پارامتر</label>
            <input
              type="text"
              value={data?.parameter}
              id="mcParameter"
              disabled
              readOnly
              className="form-control bg-light disabled"
            />
          </div>
          <div className="col-12">
            <label htmlFor="mcList">مقادیر</label>
            <input
              type="text"
              value={data?.list}
              id="mcList"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(data, "list", e.target.value, unique_id)
              }
            />
          </div>
          <div className="col-12 col-md-6 col-lg-3">
            <label htmlFor="mcDescription">عنوان</label>
            <input
              type="text"
              value={data?.description}
              id="mcDescription"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "description",
                  e.target.value,
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6 col-lg-9">
            <label htmlFor="mcDescriptionExtra">توضیحات اضافه</label>
            <input
              type="text"
              value={data?.description_extra}
              id="mcDescriptionExtra"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "description_extra",
                  e.target.value,
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12">
            <label htmlFor="mcAlert">هشدار</label>
            <input
              type="text"
              value={data?.alert}
              id="mcAlert"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(data, "alert", e.target.value, unique_id)
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

const ImageType = ({ data, unique_id }) => {
  const { handleEditParamValue } = useContext(serviceAdminContext);

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6">
            <label htmlFor="imgName">عنوان پارامتر</label>
            <input
              type="text"
              value={data?.name}
              id="imgName"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(data, "name", e.target.value, unique_id)
              }
            />
          </div>
          <div className="col-12 col-md-6">
            <label htmlFor="imgParameter">نام پارامتر</label>
            <input
              type="text"
              value={data?.parameter}
              id="imgParameter"
              disabled
              readOnly
              className="form-control bg-light disabled"
            />
          </div>
          <div className="col-12 col-md-6 col-lg-3">
            <label htmlFor="imgDescription">عنوان</label>
            <input
              type="text"
              value={data?.description}
              id="imgDescription"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "description",
                  e.target.value,
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6 col-lg-9">
            <label htmlFor="imgDescriptionExtra">توضیحات اضافه</label>
            <input
              type="text"
              value={data?.description_extra}
              id="imgDescriptionExtra"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "description_extra",
                  e.target.value,
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12">
            <label htmlFor="imgAlert">هشدار</label>
            <input
              type="text"
              value={data?.alert}
              id="imgAlert"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(data, "alert", e.target.value, unique_id)
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

const DateType = ({ data, unique_id }) => {
  const { handleEditParamValue } = useContext(serviceAdminContext);

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6">
            <label htmlFor="dName">عنوان پارامتر</label>
            <input
              type="text"
              value={data?.name}
              id="dName"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(data, "name", e.target.value, unique_id)
              }
            />
          </div>
          <div className="col-12 col-md-6">
            <label htmlFor="dParameter">نام پارامتر</label>
            <input
              type="text"
              value={data?.parameter}
              id="dParameter"
              disabled
              readOnly
              className="form-control bg-light disabled"
            />
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <label htmlFor="dStart_hour">ساعت شروع</label>
            <input
              type="number"
              value={data?.start_hour}
              id="dStart_hour"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "start_hour",
                  Number(e.target.value),
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <label htmlFor="dEnd_hour">حداکثر</label>
            <input
              type="number"
              value={data?.end_hour}
              id="dEnd_hour"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "end_hour",
                  Number(e.target.value),
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <label htmlFor="dInterval">بازه زمانی</label>
            <input
              type="number"
              value={data?.interval}
              id="dInterval"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "interval",
                  Number(e.target.value),
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6">
            <label htmlFor="dWait_time">تاخیر نسبت به زمان ثبت سفارش</label>
            <input
              type="number"
              value={data?.wait_time}
              id="dWait_time"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "wait_time",
                  Number(e.target.value),
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6">
            <label htmlFor="dWait_type">نوع تاخیر</label>
            <select
              value={data?.wait_type}
              id="dWait_type"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "wait_type",
                  Number(e.target.value),
                  unique_id
                )
              }
            >
              <option value="0" selected={0 === data?.wait_type}>
                دقیقه
              </option>
              <option value="1" selected={1 === data?.wait_type}>
                ساعت
              </option>
              <option value="2" selected={2 === data?.wait_type}>
                روز
              </option>
            </select>
          </div>
          <div className="col-12 col-md-6 col-lg-3">
            <label htmlFor="dDescription">عنوان</label>
            <input
              type="text"
              value={data?.description}
              id="dDescription"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "description",
                  e.target.value,
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6 col-lg-9">
            <label htmlFor="dDescriptionExtra">توضیحات اضافه</label>
            <input
              type="text"
              value={data?.description_extra}
              id="dDescriptionExtra"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "description_extra",
                  e.target.value,
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12">
            <label htmlFor="dAlert">هشدار</label>
            <input
              type="text"
              value={data?.alert}
              id="dAlert"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(data, "alert", e.target.value, unique_id)
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

const TimeType = ({ data, unique_id }) => {
  const { handleEditParamValue } = useContext(serviceAdminContext);

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6">
            <label htmlFor="tName">عنوان پارامتر</label>
            <input
              type="text"
              value={data?.name}
              id="tName"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(data, "name", e.target.value, unique_id)
              }
            />
          </div>
          <div className="col-12 col-md-6">
            <label htmlFor="tParameter">نام پارامتر</label>
            <input
              type="text"
              value={data?.parameter}
              id="tParameter"
              disabled
              readOnly
              className="form-control bg-light disabled"
            />
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <label htmlFor="tStart_hour">ساعت شروع</label>
            <input
              type="number"
              value={data?.start_hour}
              id="tStart_hour"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "start_hour",
                  Number(e.target.value),
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <label htmlFor="tEnd_hour">حداکثر</label>
            <input
              type="number"
              value={data?.end_hour}
              id="tEnd_hour"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "end_hour",
                  Number(e.target.value),
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <label htmlFor="tInterval">بازه زمانی</label>
            <input
              type="number"
              value={data?.interval}
              id="tInterval"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "interval",
                  Number(e.target.value),
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6">
            <label htmlFor="tWait_time">تاخیر نسبت به زمان ثبت سفارش</label>
            <input
              type="number"
              value={data?.wait_time}
              id="tWait_time"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "wait_time",
                  Number(e.target.value),
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6">
            <label htmlFor="tWait_type">نوع تاخیر</label>
            <select
              value={data?.wait_type}
              id="tWait_type"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "wait_type",
                  Number(e.target.value),
                  unique_id
                )
              }
            >
              <option value="0" selected={0 === data?.wait_type}>
                دقیقه
              </option>
              <option value="1" selected={1 === data?.wait_type}>
                ساعت
              </option>
              <option value="2" selected={2 === data?.wait_type}>
                روز
              </option>
            </select>
          </div>
          <div className="col-12 col-md-6 col-lg-3">
            <label htmlFor="tDescription">عنوان</label>
            <input
              type="text"
              value={data?.description}
              id="tDescription"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "tescription",
                  e.target.value,
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6 col-lg-9">
            <label htmlFor="tDescriptionExtra">توضیحات اضافه</label>
            <input
              type="text"
              value={data?.description_extra}
              id="tDescriptionExtra"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "tDescriptionExtra",
                  e.target.value,
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12">
            <label htmlFor="tAlert">هشدار</label>
            <input
              type="text"
              value={data?.alert}
              id="tAlert"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(data, "alert", e.target.value, unique_id)
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

const RadiobuttonType = ({ data, unique_id }) => {
  const { handleEditParamValue } = useContext(serviceAdminContext);

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6">
            <label htmlFor="rName">عنوان پارامتر</label>
            <input
              type="text"
              value={data?.name}
              id="rName"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(data, "name", e.target.value, unique_id)
              }
            />
          </div>
          <div className="col-12 col-md-6">
            <label htmlFor="rParameter">نام پارامتر</label>
            <input
              type="text"
              value={data?.parameter}
              id="rParameter"
              disabled
              readOnly
              className="form-control bg-light disabled"
            />
          </div>
          <div className="col-12">
            <label htmlFor="rList">مقادیر</label>
            <input
              type="text"
              value={data?.list}
              id="rList"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(data, "list", e.target.value, unique_id)
              }
            />
          </div>
          <div className="col-12 col-md-6 col-lg-3">
            <label htmlFor="rDescription">عنوان</label>
            <input
              type="text"
              value={data?.description}
              id="rDescription"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "description",
                  e.target.value,
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12 col-md-6 col-lg-9">
            <label htmlFor="rDescriptionExtra">توضیحات اضافه</label>
            <input
              type="text"
              value={data?.description_extra}
              id="rDescriptionExtra"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(
                  data,
                  "description_extra",
                  e.target.value,
                  unique_id
                )
              }
            />
          </div>
          <div className="col-12">
            <label htmlFor="rAlert">هشدار</label>
            <input
              type="text"
              value={data?.alert}
              id="rAlert"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(data, "alert", e.target.value, unique_id)
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

const ItemParam = ({ data, unique_id, parentStep }) => {
  const {
    parameterType,
    setParameterType,
    handleEditParamValue,
    handleAddParam,
    handleDeleteParamValue,
    handleEditParamOrder,
  } = useContext(serviceAdminContext);

  const [step, setStep] = useState(0);

  const renderParam = (_val) => {
    let render = null;

    switch (_val?.type) {
      case "radiobutton":
        render = <RadiobuttonType data={_val} unique_id={data?.unique_id} />;
        break;
      case "text":
        render = <TextType data={_val} unique_id={data?.unique_id} />;
        break;
      case "multiplechoice":
        render = <MultiplechoiceType data={_val} unique_id={data?.unique_id} />;
        break;
      case "datetime":
        render = <DateTimeType data={_val} unique_id={data?.unique_id} />;
        break;
      case "date":
        render = <DateType data={_val} unique_id={data?.unique_id} />;
        break;
      case "time":
        render = <TimeType data={_val} unique_id={data?.unique_id} />;
        break;
      case "number":
        render = <NumberType data={_val} unique_id={data?.unique_id} />;
        break;
      case "switch":
        render = <SwitchType data={_val} unique_id={data?.unique_id} />;
        break;
      case "image":
        render = <ImageType data={_val} unique_id={data?.unique_id} />;
        break;
      case "item":
        render = (
          <ItemParam
            data={_val}
            unique_id={data?.unique_id}
            parentStep={step}
          />
        );
        break;

      default:
        render = null;
        break;
    }

    return <div>{render}</div>;
  };

  useEffect(() => {
    setStep(0);
  }, [parentStep]);

  const paramsLength = data?.params?.length;
  const items = data?.params?.sort((a, b) => a?.order - b?.order);
  const item = items[step];

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6">
            <label htmlFor="iName">نام</label>
            <input
              type="text"
              value={data?.name}
              id="iName"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(data, "name", e.target.value, unique_id)
              }
            />
          </div>
          <div className="col-12 col-md-6">
            <label htmlFor="iParameter">کد چهار حرفی یکتا</label>
            <input
              type="text"
              value={data?.unique_id}
              id="iParameter"
              disabled
              readOnly
              className="form-control bg-light disabled"
            />
          </div>
          <div className="col-12">
            <label htmlFor="iAlert">هشدار</label>
            <input
              type="text"
              value={data?.alert}
              id="iAlert"
              className="form-control"
              onChange={(e) =>
                handleEditParamValue(data, "alert", e.target.value, unique_id)
              }
            />
          </div>
          {/* <div className="col-12 col-md-6">
            <div className="custom-control custom-switch mb-2">
              <input
                type="checkbox"
                className="custom-control-input"
                id="iMulti"
                checked={data?.multi}
                onChange={(e) =>
                  handleEditParamValue(
                    data,
                    "multi",
                    e.target.checked,
                    unique_id
                  )
                }
              />
              <label className="custom-control-label" htmlFor="iMulti">
                چندتایی
              </label>
            </div>
          </div> */}
        </div>
        <hr />
        <form
          onSubmit={(e) => handleAddParam(e, data, setStep)}
          autoComplete="off"
        >
          <div className="row align-items-end">
            <div className="col-10 mb-2">
              <label htmlFor="name">نوع پارامتر</label>
              <select
                className="form-control"
                name="type"
                onChange={(e) => setParameterType(Number(e.target.value))}
              >
                <option selected disabled hidden>
                  لطفا نوع پارامتر را انتخاب کنید
                </option>
                {serviceParameters?.map((_value, index) => (
                  <option
                    key={index}
                    selected={index === parameterType}
                    value={index}
                  >
                    {_value}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-2 mb-2">
              <button className="btn btn-warning btn-block" type="submit">
                <i className="fas fa-check mr-2"></i>
                افزودن به آیتم
              </button>
            </div>
          </div>
        </form>
        {!isEmpty(items) && !isEmpty(item) && (
          <section>
            <div
              key={item?.parameter}
              className="border border-secondary card card-body"
            >
              <div>{renderParam(item)}</div>
              <div className="d-flex justify-content-between align-items-center my-3">
                <div>
                  <button
                    className="btn btn-outline-info"
                    type="button"
                    onClick={() => handleEditParamOrder(step, data, false)}
                    disabled={step <= 0}
                  >
                    انتقال به مرحله قبل
                  </button>
                </div>
                <div>
                  <button
                    className="btn btn-outline-danger"
                    type="button"
                    onClick={() => {
                      handleDeleteParamValue(item, data?.unique_id);
                      if (step >= paramsLength - 1) setStep(step - 1);
                    }}
                  >
                    حذف این مرحله
                  </button>
                </div>
                <div>
                  <button
                    className="btn btn-outline-info"
                    type="button"
                    onClick={() => handleEditParamOrder(step + 1, data, true)}
                    disabled={step >= paramsLength - 1}
                  >
                    انتقال به مرحله بعد
                  </button>
                </div>
              </div>
            </div>

            <PaginationList
              initialPage={step}
              setPageNumber={(page) => setStep(page - 1)}
              pageCount={paramsLength}
            />
          </section>
        )}
      </div>{" "}
    </>
  );
};
